// extracted by mini-css-extract-plugin
module.exports = {"container":"ArtistBio_container__Rov-0","columnContainer":"ArtistBio_columnContainer__US0JX","header":"ArtistBio_header__2h3s5","bounce":"ArtistBio_bounce__3S2fQ"};